import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { LanguageTypes } from "../types";

export const useLanguage = (): {
  direction: "ltr" | "rtl";
  language: LanguageTypes;
  setLanguage: (locale: LanguageTypes) => Promise<void>;
} => {
  const { i18n } = useTranslation();
  const language = i18n.language as LanguageTypes;
  const direction = i18n.dir() as "ltr" | "rtl";

  const setLanguage = useCallback(
    async (locale: LanguageTypes) => {
      localStorage.setItem("lng", locale);
      await i18n.changeLanguage(locale);
    },
    [i18n]
  );

  return useMemo(
    () => ({ direction, language, setLanguage }),
    [direction, language, setLanguage]
  );
};
